import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 当前登录用户，以供全局使用
    user: {
      id: '',
      name: '',
      role: '',
      account: ''
    }
  },
  getters: {
  },
  mutations: {
    updateUserInfo (state, payload) {
      state.user = payload.user
    },
    initUserInfo (state) {
      state.user = {
        id: '',
        name: '',
        role: '',
        account: ''
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
